export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapCorridors';
export const ENTITY_EDIT_ROUTE = 'corridors/view';
